import React, { useEffect, createRef } from 'react';
import ContentCard from '../../../common/ContentCard';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getUserLitterCount, getPiecesCollectedLoading } from '../selectors';
import { numberWithCommas } from '../../../common/utils';
import { piecesCollectedRequested } from '../actions';
import LoadingComponent from '../../../common/LoadingComponent';
import downloadAsImage from '../../../helpers/downloadAsImage';
import './styles.scss';

function TotalLitterPieces({ onLoad, litterCount, loading }) {
    useEffect(() => {
        onLoad();
    }, []);

    const ref = createRef();
    const loader = (
        <div className="piecesLoader">
            <LoadingComponent isLoading={loading} />
        </div>
    );

    const mainContent = loading ? (
        loader
    ) : (
        <h3 className="title-secondary f-80">
            <div>
                <span>{numberWithCommas(litterCount)} </span>
            </div>
        </h3>
    );

    return (
        <ContentCard
            heading={'Pieces Collected'}
            subHeading={'Total pieces picked up by your sponsored challenges.'}
            showDropDown={false}
            content={mainContent}
            downloadable={true}
            id="piecesCollected"
            onDownloadClick={(filetype) => {
                if (ref) {
                    downloadAsImage(ref.current, 'piecesCollected', filetype);
                }
            }}
            ref={ref}
        />
    );
}

TotalLitterPieces.propTypes = {
    // total Pieces Collected to display in card
    litterCount: PropTypes.number.isRequired,
    // function to fetch total pieces collected
    onLoad: PropTypes.func.isRequired,
    // loading state of api call
    loading: PropTypes.bool,
};

TotalLitterPieces.defaultProps = {
    loading: false,
};

const mapStateToProps = (state) => {
    return {
        litterCount: getUserLitterCount(state),
        loading: getPiecesCollectedLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => dispatch(piecesCollectedRequested()),
    };
};

const ConnectedPieces = connect(
    mapStateToProps,
    mapDispatchToProps,
)(TotalLitterPieces);

export default ConnectedPieces;
